import React from 'react';

const LogoGoogleCalendarSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.3 7.9c-1.1 0-1.9.4-2.3 1.2-.3.4-.4.8-.4 1.5h1c0-.5.1-.7.3-1 .3-.5.8-.7 1.5-.7.4 0 .8.1 1.1.4.3.2.4.6.4 1 0 .6-.2 1-.7 1.2-.3.1-1.6.3-1.6.3v.7s1.2-.1 2 .4c.4.2.6.6.6 1.2 0 .5-.2.9-.5 1.2-.3.3-.8.5-1.3.5-.7 0-1.2-.2-1.5-.7-.2-.2-.3-.6-.3-1.1H6.4c0 .8.2 1.4.7 1.9.5.6 1.2.8 2.2.8 1 0 1.7-.3 2.3-.8.5-.5.8-1.2.8-2 0-.5-.1-.9-.4-1.3-.3-.4-.6-.6-1-.7.3-.1.5-.3.7-.5.3-.3.4-.7.4-1.3 0-.7-.2-1.3-.7-1.7-.6-.4-1.2-.5-2.1-.5zm7.5 8.5V7.9H16c-.2.7-.4 1.1-.7 1.2-.3.2-.7.3-1.5.4v.8h1.9v6h1.1zM6.8 4.6c-.4 0-.8.4-.8.8s.3.7.8.7c.4 0 .7-.3.7-.7 0-.4-.3-.8-.7-.8zm10.4 0c-.4 0-.8.3-.8.7 0 .4.3.7.8.7.4 0 .7-.3.7-.7 0-.3-.3-.7-.7-.7zM3.1 2.9h17.8c.6 0 1.1.9 1.1 1.5v11.3L16.4 21H3.1c-.6 0-1.1-.5-1.1-1.1V4.1c0-.7.5-1.2 1.1-1.2z"
        />
    </svg>
);

LogoGoogleCalendarSvg.displayName = 'LogoGoogleCalendarSvg';
export default LogoGoogleCalendarSvg;
